import type { ThemeDraft } from './api';

const THEME_KEYS = [
  'paper',
  'surface',
  'ink',
  'text',
  'text-muted',
  'brand',
  'brand-hover',
  'teal',
  'green',
  'line',
  'text-on-ink',
  'text-on-ink-muted',
  'font-display',
  'font-body',
  'font-mono',
  'radius',
  'radius-btn',
] as const;

/**
 * Builds an inline style string of known theme CSS variables.
 * Ignores unknown keys and empty values so a partial draft still paints.
 */
export function themeToInlineStyle(theme: ThemeDraft | null): string {
  if (theme === null) {
    return '';
  }
  const parts: string[] = [];
  for (const key of THEME_KEYS) {
    const value = theme[key];
    if (typeof value === 'string' && value.trim().length > 0) {
      parts.push(`--${key}: ${value}`);
    }
  }
  return parts.join('; ');
}
